<template>
  <component :is="switchTheme"></component>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import AppFooterBlack from "./AppFooterBlack";
import AppFooterWhite from "./AppFooterWhite";
export default {
  mixins: [siteMixin],
  data() {
    return {
      black: AppFooterBlack,
      white: AppFooterWhite,
    };
  },
  computed: {
    switchTheme() {
      switch (this.siteConfig.theme) {
        case "overall":
        case "fresh":
          return this.black;
          break;
        default:
          return this.white;
          break;
      }
    },
  },
  methods: {},
  components: {
    AppFooterBlack,
    AppFooterWhite,
  },
};
</script>

<style lang="less">
@import "../../assets/css/var";
</style>